// What Intl.ListFormat would put before the last name, for the app's
// languages: Hermes ships no ListFormat, and a bare comma join reads as a
// fragment ("Ana, Leo stay here").
const LAST_JOIN: Record<string, { two: string; many: string }> = {
  en: { two: ' and ', many: ', and ' },
  es: { two: ' y ', many: ' y ' },
  fr: { two: ' et ', many: ' et ' },
  pt: { two: ' e ', many: ' e ' },
  de: { two: ' und ', many: ' und ' },
};

/**
 * Names joined as "A, B and C" in the reader's language: through
 * `Intl.ListFormat` where it exists, otherwise by the table above (a
 * language outside it gets a comma join).
 */
export function formatNameList(names: string[], language: string): string {
  const ListFormat = (Intl as { ListFormat?: typeof Intl.ListFormat })
    .ListFormat;
  if (typeof ListFormat === 'function')
    return new ListFormat(language, {
      style: 'long',
      type: 'conjunction',
    }).format(names);
  const join = LAST_JOIN[language.split('-')[0] ?? ''];
  if (!join || names.length < 2) return names.join(', ');
  const head = names.slice(0, -1).join(', ');
  return `${head}${names.length === 2 ? join.two : join.many}${names[names.length - 1]}`;
}
